<div class="component-announcements component-tooltipContainer bulkOperationAnnouncements"
     (clickOutside)="hideContractBulkOperations();"
     *ngIf="existContractBulkOperation">
    <a (click)="toggleContractBulkOperations()" class="fa fa-clock-o">
    </a>
    <section class="component-tooltip positionedBottomRight pointerHeaderTopRight"
             [ngClass]="{'opened': showBulkOperations === true}">
        <header>
            <h1 class="fa fa-clock-o">Historie hromadných operací</h1>
        </header>
        <div class="component-tooltip-content" >
            <ca-loading [loadState]="contractBulkOperationsLoading">
            <div class="scrollable nativeScrollbar inside silver">
                <table class="component-tabulatedList">
                    <thead>
                    <tr>
                        <th>Název operace</th>
                        <th>Stav</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let bulkAction of bulkOperations; trackBy:bulkAction?.id">
                        <td>
                            <a *ngIf="bulkAction.state === 'DONE'" routerLink="/bulkOperation">
                                {{ bulkAction.actionType | displayContractBulkActionTypeName }}
                            </a>
                            <span *ngIf="bulkAction.state !== 'DONE'">
                                {{ bulkAction.actionType | displayContractBulkActionTypeName }}
                            </span>
                        </td>
                        <td>
                            {{ bulkAction | displayContractBulkActionState }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            </ca-loading>
            <footer>
                <a  routerLink="/bulkOperation"
                    (click)="logBulkOperationsNavigation();"
                    class="button-secondary">
                    Zobrazit kompletní historii operací
                </a>
            </footer>
        </div>
    </section>
    <section class="component-tooltip pointerHeaderTopRight" [ngClass]="{'opened': showBulkOperations === true}"
             *ngIf="bulkOperations.length === 0 && !contractBulkOperationsLoading">
        <header>
            <h1 class="fa fa-clock-o">
                Historie hromadných operací
            </h1>
        </header>
        <div class="component-tooltip-content notificationNoSection">
            <p>Během posledních 7 dnů nebyla provedena žádná hromadná operace.</p>
        </div>
        <footer>
            <a  routerLink="/bulkOperation"
                (click)="logBulkOperationsNavigation();"
                class="button-secondary">
                Zobrazit kompletní historii operací
            </a>
        </footer>
    </section>
</div>